import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export class Pallax {
  constructor() {
    if (document.querySelectorAll('.js-pallax_trigger') === null) return
    const triggerList = document.querySelectorAll('.js-pallax_trigger')
    const triggerArr = Array.prototype.slice.call(triggerList, 0)

    triggerArr.forEach(function (trigger) {
      gsap.registerPlugin(ScrollTrigger)
      let arr = Array.prototype.slice.call(trigger.querySelectorAll('.js-pallax_elm'))
      arr.forEach(function (elm) {
        let y = elm.getAttribute('data-y')
        if (window.innerWidth < 1025) {
          y = y * 0.5
        }
        gsap.to(elm, {
          y: '-=' + y,
          duration: elm.getAttribute('data-duration'),
          scrollTrigger: {
            trigger: trigger,
            start: 'top center',
            end: '+=80% center',
            scrub: 1,
            markers: false,
          },
        })
      })
    })
  }
}
